import React from 'react';
import SmallBlueButton from '@components/common/button/SmallBlueButton';
import { FieldArray, FormikProps } from 'formik';
import SectionInfo from './SectionInfo';
import StyledErrorMessage from '@components/common/form/formik/input/StyledErrorMessage';
import { FormCourseDataOnly } from '../../CourseDataInfoBox';
import { TimeZone } from '@data/course/courseData';

const SectionsInfo = (props: FormikProps<FormCourseDataOnly>) => {
  const sections = props.values.sections;

  return (
    <FieldArray
      name='sections'
      render={(arrayHelpers) => (
        <>
          {sections.length > 0 ? (
            sections.map((section, sectionIndex) => (
              <div key={sectionIndex} className='bg-cultured p-4 mt-8'>
                <SectionInfo
                  meetingsLength={section.meetings.length}
                  sectionIndex={sectionIndex}
                  removeSelf={() => arrayHelpers.remove(sectionIndex)}
                  canRemove={sections.length > 1}
                />
              </div>
            ))
          ) : (
            <p className='text-3xl font-raleway text-deepspace mt-8'>No Sections.</p>
          )}
          <SmallBlueButton
            text='ADD SECTION'
            onClick={() => arrayHelpers.push({ meetings: [], timeZone: TimeZone['Etc/Greenwich'] })}
            clickable={sections.length < 2}
          />
          <StyledErrorMessage name='sections'></StyledErrorMessage>
        </>
      )}
    />
  );
};

export default SectionsInfo;
